export default function buildGetSingleProducer({
    apiEndpoint,
    apiTools
}) {
    return async function getSingleProducer(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }`
        })
       
        const res = await fetch(url, {
            method: 'GET',
            credentials: 'include',
        });
        return await res.json();
    }
}